import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-responsive-modal";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { v4 as uuidv4 } from "uuid";
import { FaFacebook, FaLinkedin, FaGoogle } from "react-icons/fa";
import PDF from "../../../../assets/images/pdf.svg";
import { getCampaignView } from "../../../../redux/actions/campaignActions";
import { getCampaignRatingsAdmin } from "../../../../redux/actions/dealFlowActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import ProfilePic from "../../../../assets/images/dummy_profile.png";
import { AdminStarRating, InterestStatsPanel } from "../../../../components/DealFlow";
import { canApprove, isEvaluator } from "../../../../utils/dealFlowRoleUtils";
import { getErrorMessage } from "../../../../utils/errorUtils";
import "../../../../components/common/css/campaignview.scss";
import "../../../../components/common/css/modal.scss";

const ReviewCampaign = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState("panel1");
  const [previewData, setPreviewData] = useState([]);
  const [business_plan_docs, setBuiness_Plan_Docs] = useState([]);
  const [other_docs, setOther_Docs] = useState([]);
  const dispatch = useDispatch();
  const campaignView = useSelector((state) => state.campaignView);
  const { campaign } = campaignView;
  const dealFlow = useSelector((state) => state.dealFlow);
  const [productsType, setProductsType] = useState([]);
  const [productId, setProductId] = useState();

  const navigate = useNavigate();
  const { campaignId: campaignIdParam } = useParams();
  const token = localStorage.getItem("accessToken");
  const adminId = JSON.parse(localStorage.getItem("admin"))?.data?.id;
  const campaignId = campaignIdParam ? Number(campaignIdParam) : null;
  const ratingsData = dealFlow?.ratings?.[campaignId] || null;
  const myRating =
    ratingsData?.individual_ratings?.find((rating) => rating?.user_id === adminId) ||
    null;
  const d = new Date(campaign?.data[0]?.user?.dob);
  let campaign_id = campaign?.data[0]?.id?.toString()?.padStart(8, "0");
  const campaignType = campaign?.data?.[0]?.type;
  const campaignUserId = campaignView?.campaign?.data?.[0]?.user_id;
  const campaignSlug = campaignView?.campaign?.data?.[0]?.slug;

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }));

  const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
      {...props}
    />
  ))(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255, 255, 255, .05)"
        : "rgba(0, 0, 0, .03)",
    flexDirection: "row-reverse",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(90deg)",
    },
    "& .MuiAccordionSummary-content": {
      marginLeft: theme.spacing(1),
    },
  }));

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, .125)",
  }));

  const getProducts = useCallback(() => {
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-campaign-products",
      headers: {
        "x-access-token": token,
      },
      data: {
        type: campaignType,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data;

        setProductsType(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [token, campaignType]);

  useEffect(() => {
    if (campaignIdParam) {
      dispatch(getCampaignView(token, { campaignId: campaignIdParam }));
    }
  }, [dispatch, token, campaignIdParam]);

  useEffect(() => {
    if (campaignId) {
      dispatch(getCampaignRatingsAdmin(campaignId));
    }
  }, [dispatch, campaignId]);

  useEffect(() => {
    if (campaignView) {
      if (campaignView?.loading !== undefined) {
        setLoading(campaignView?.loading);
      }
      setBuiness_Plan_Docs(
        campaignView?.campaign?.data[0]?.business_plan_docs?.filter(
          (x) => x.is_other === 0
        )
      );
      setOther_Docs(
        campaignView?.campaign?.data[0]?.business_plan_docs?.filter(
          (x) => x.is_other === 1
        )
      );
    }
  }, [campaignView]);

  const approveCampaign = () => {
    let current_date = new Date();
    // date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/approve-admin-review",
      headers: {
        "x-access-token": token,
      },
      data: {
        slug: campaign?.data[0]?.slug,
        user_id: campaign?.data[0]?.user_id,
        campaign_id: campaignIdParam,
        status: 3,
        product_type: productId,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status === 200) {
          setLoading(false);
          Swal.fire({
            title: "Approved Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        if (new Date(previewData?.[0]?.step_seven?.launchDate) > current_date) {
          navigate("/coming-soon-campaign");
        } else {
          navigate("/active-campaign");
        }
      })
      .catch(function (error) {
        setLoading(false);
        const errorMessage = getErrorMessage(
          error,
          "Failed to approve campaign"
        );
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: errorMessage,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      });
  };

  const declineCampaign = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/approve-admin-review",
      headers: {
        "x-access-token": token,
      },
      data: {
        slug: campaign?.data[0]?.slug,
        user_id: campaign?.data[0]?.user_id,
        campaign_id: campaignIdParam,
        status: 2,
      },
    };

    axios(config)
      .then(function (response) {
        if (response.data.status === 200) {
          setLoading(false);
          Swal.fire({
            title: "Rejected Succesffully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        navigate("/rejected-campaign");
      })
      .catch(function (error) {
        setLoading(false);
        const errorMessage = getErrorMessage(
          error,
          "Failed to reject campaign"
        );
        Swal.fire({
          title: errorMessage,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  const previewCampaign = useCallback(() => {
    const accessToken = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/get-campaigndetails-listby-slug",
      headers: {
        "x-access-token": accessToken,
      },
      data: {
        campaign_id: campaignIdParam,
        user_id: campaignUserId,
        slug: campaignSlug,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPreviewData(response.data.data.rows);
      })
      .catch(function (error) {
        setLoading(false);
        const errorMessage = getErrorMessage(error, "Failed to load campaign");
        Swal.fire({
          title: errorMessage,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  }, [campaignIdParam, campaignSlug, campaignUserId]);

  useEffect(() => {
    if (
      campaignView?.campaign?.status === 200 &&
      campaignView?.campaign?.success === true
    ) {
      previewCampaign();
      getProducts();
    }
  }, [campaignView, getProducts, previewCampaign]);
  // console.loh("previewDatapreviewData",previewData)
  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <Loader isLoading={loading} />

        <div className="top">
          {campaign?.data?.map((userInfo) => (
            <div key={userInfo?.user_id}>
              <div className="left">
                <div className="topHeading">
                  <h1 className="title">Personal Information</h1>

                  <button onClick={onOpenModal} className="editButton">
                    Log History
                  </button>
                </div>

                <div className="item">
                  <img
                    src={
                      userInfo?.user?.profilePic
                        ? userInfo?.user?.profilePic
                        : ProfilePic
                    }
                    alt="Profile"
                    className="itemImg"
                  />
                  <div className="details profile-info">
                    {/* <h1 className="itemTitle">
                      {userInfo.user.firstname} {userInfo.user.lastname}
                    </h1> */}
                    <div className="detailItem">
                      <span className="itemKey">Name:</span>
                      <span className="itemValue">
                        <b>
                          {userInfo?.user?.salutations}&nbsp;
                          {userInfo.user.firstname} {userInfo?.user?.lastname}
                        </b>
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Email:</span>
                      <span className="itemValue">{userInfo.user.email}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Phone:</span>
                      <span className="itemValue">
                        {userInfo?.user?.phone === "null"
                          ? ""
                          : userInfo?.user?.phone}
                      </span>
                    </div>
                    {/* <div className="detailItem">
                      <span className="itemKey">Status:</span>

                      <span className="itemValue">
                        {userInfo?.campaign_status == 5
                          ? "In Review"
                          : "Inactive"}
                      </span>
                    </div> */}
                    <div className="detailItem">
                      <span className="itemKey">Current Address:</span>
                      <span className="itemValue">
                        {userInfo?.user?.current_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Floor:</span>
                      <span className="itemValue">
                        {userInfo?.user?.address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">City:</span>
                      <span className="itemValue">{userInfo?.user?.city}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Postal Code:</span>
                      <span className="itemValue">
                        {userInfo?.user?.postal_code}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country:</span>
                      <span className="itemValue">
                        {userInfo?.user?.user_country?.country_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province:</span>
                      <span className="itemValue">
                        {userInfo?.user?.user_state?.state_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">DOB:</span>
                      <span className="itemValue">
                        {d?.toLocaleDateString()}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Gender:</span>
                      <span className="itemValue">
                        {userInfo?.user?.gender}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Marital Status:</span>
                      <span className="itemValue">
                        {userInfo?.user?.marital_status}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Employer:</span>
                      <span className="itemValue">
                        {userInfo?.user?.employer}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Occupation:</span>
                      <span className="itemValue">
                        {userInfo?.user?.occupation}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Sin:</span>
                      <span className="itemValue">{userInfo?.user?.sin}</span>
                    </div>
                    {/* <div className="detailItem">
                      <span className="itemKey">Cell:</span>
                      <span className="itemValue">
                        {userInfo?.user?.mobile}
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="left">
                {/* <div className="editButton">Edit</div> */}
                <h1 className="title">Corporate Information</h1>
                <div className="item">
                  <img
                    src={
                      userInfo?.campaing_logo
                        ? userInfo?.campaing_logo
                        : ProfilePic
                    }
                    alt="Campaign"
                    className="itemCorpImg"
                  />
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Campaign ID:</span>
                      <span className="itemValue">{campaign_id}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Name:</span>
                      <span className="itemValue">
                        {userInfo.corporation_legal_name}
                      </span>
                    </div>
                    {userInfo?.type === "FUND" && (
                      <>
                        <div className="detailItem">
                          <span className="itemKey">Fund Name:</span>
                          <span className="itemValue">
                            {userInfo.fund_name || userInfo.campaign_name}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Fund Type:</span>
                          <span className="itemValue">
                            {userInfo.fund_type_description || "Not specified"}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">One-Line Description:</span>
                          <span className="itemValue">
                            {userInfo.one_line_description || "Not specified"}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Risk Profile:</span>
                          <span className="itemValue">
                            {userInfo.risk_profile || "Not specified"}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Investment Horizon:</span>
                          <span className="itemValue">
                            {userInfo.investment_horizon || "Not specified"}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Target ARR:</span>
                          <span className="itemValue">
                            {userInfo.target_arr || "Not specified"}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Fund Summary:</span>
                          <span className="itemValue">
                            {userInfo.fund_summary || "Not specified"}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Key Reasons:</span>
                          <span className="itemValue">
                            {userInfo.key_reasons_to_invest || "Not specified"}
                          </span>
                        </div>
                        <div className="detailItem">
                          <span className="itemKey">Company Overview:</span>
                          <span className="itemValue">
                            {userInfo.company_overview || "Not specified"}
                          </span>
                        </div>
                      </>
                    )}
                    <div className="detailItem">
                      <span className="itemKey">Company Location:</span>
                      <span className="itemValue">{userInfo.city}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Campaign Type:</span>
                      <span className="itemValue">{userInfo.campaign_for}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Head Office Address</span>
                      <span className="itemValue">
                        {userInfo?.registered_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Phone:</span>
                      <span className="itemValue">{userInfo?.phone}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Email:</span>
                      <span className="itemValue">{userInfo?.camp_email}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country</span>
                      <span className="itemValue">
                        {userInfo?.user_country?.country_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province</span>
                      <span className="itemValue">
                        {userInfo?.user_state?.state_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Postal Code</span>
                      <span className="itemValue">{userInfo?.postal_code}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Type Of Enitity:</span>
                      <span className="itemValue">{userInfo.entitytype}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Website</span>
                      <span className="itemValue">{userInfo?.website}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Buisness No:</span>
                      <span className="itemValue">{userInfo.business}</span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Fax</span>
                      <span className="itemValue">{userInfo.fax}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Crax Acoount</span>
                      <span className="itemValue">
                        {userInfo.craax_account}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Date Of Corp</span>
                      <span className="itemValue">
                        {userInfo.date_of_incorp}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Incorp Register</span>
                      <span className="itemValue">
                        {userInfo?.in_corporation_registration}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Currency</span>
                      <span className="itemValue">
                        CAD{/* {userInfo?.user?.defaultcurrency} */}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Goal Amount</span>
                      <span className="itemValue">
                        {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                        ${userInfo?.goal_invest_amnt}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Minimum Investment</span>
                      <span className="itemValue">
                        {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                        ${userInfo?.minimum_investment}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Other Investment</span>
                      <span className="itemValue">
                        {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                        ${userInfo?.outside_roots_investment}
                      </span>
                    </div>
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">Company Valuation</span>
                        <span className="itemValue">
                          {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                          ${userInfo?.company_valuation}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">In Which Form</span>
                        <span className="itemValue">{userInfo?.loan_type}</span>
                      </div>
                    )}
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">No Closing Minimum</span>
                        <span className="itemValue">
                          {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                          ${userInfo?.no_closing_minimum}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          Brief description on how you will use this funds
                        </span>
                        <span className="itemValue">{userInfo?.fund_use}</span>
                      </div>
                    )}
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">Price per security</span>
                        <span className="itemValue">
                          {userInfo?.price_per_security}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          Which Is The Purpose Of This Financing?
                        </span>
                        <span className="itemValue">
                          {userInfo?.purpose_of_financing}
                        </span>
                      </div>
                    )}
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">Security Type</span>
                        <span className="itemValue">
                          {userInfo?.security_type}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          Which return you would like to offer to the investors?
                        </span>
                        <span className="itemValue">
                          {userInfo?.interest_rate}
                        </span>
                      </div>
                    )}
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">
                          Number of shares issued in this campaign
                        </span>
                        <span className="itemValue">
                          {userInfo?.issued_shares}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          What's your desired loan's duration in months?
                        </span>
                        <span className="itemValue">
                          {userInfo?.loan_duration_in_month}
                        </span>
                      </div>
                    )}
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">
                          Total Company’s shares issued
                        </span>
                        <span className="itemValue">
                          {userInfo?.issued_shares_company}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          Can you offer any guarantees to the investor?
                        </span>
                        <span className="itemValue">
                          {userInfo?.guarantee_type}
                        </span>
                      </div>
                    )}
                    <div className="detailItem">
                      <span className="itemKey">Year Of Corporation</span>
                      <span className="itemValue">
                        {userInfo.how_many_yearsin_business}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Feature</span>
                      {Array.isArray(userInfo?.features) ? (
                        userInfo?.features.map((feature, index) => {
                          return (
                            <li className="itemValue">
                              {feature?.feature_title}
                            </li>
                          );
                        })
                      ) : (
                        <h4>No Data Found</h4>
                      )}
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Nature Of Buisness</span>
                      {Array.isArray(userInfo?.nature_of_businesses) ? (
                        userInfo?.nature_of_businesses.map((cat, index) => {
                          return (
                            <li className="itemValue">
                              {cat?.business_category?.category_name}
                            </li>
                          );
                        })
                      ) : (
                        <h4>No Data Found</h4>
                      )}
                    </div>
                    <div className="buisnessPlan">
                      <span className="itemKey">Buisness Plan Docs</span>
                      <div className="itemValue">
                        {business_plan_docs?.length > 0 ? (
                          business_plan_docs?.map((pdf, i) => (
                            <>
                              <a
                                href={pdf.document_name}
                                target="_blank"
                                rel="noreferrer"
                                className="docLink"
                              >
                                {pdf?.document_name !== null && (
                                  <img src={PDF} className="docImage" alt="Document" />
                                )}

                                {pdf?.document_name !== null && (
                                  <p className="docName">doc {i + 1}</p>
                                )}
                              </a>
                            </>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    </div>

                    <div className="buisnessPlan">
                      <span className="itemKey">Other Docs</span>
                      <div className="itemValue">
                        {other_docs?.length > 0 ? (
                          other_docs?.map((pdf, i) => (
                            <>
                              <a
                                href={pdf.document_name}
                                target="_blank"
                                rel="noreferrer"
                                className="docLink"
                              >
                                {pdf?.document_name !== null && (
                                  <img src={PDF} className="docImage" alt="Document" />
                                )}

                                {pdf?.document_name !== null && (
                                  <p className="docName">doc {i + 1}</p>
                                )}
                              </a>
                            </>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="left">
                {/* <div className="editButton">Edit</div> */}
                <h1 className="title">Campaign related Questions/Answers</h1>
                <div className="item">
                  <div className="details profile-info">
                    {userInfo.campaign_que_ans.length > 0 ? (
                      userInfo.campaign_que_ans.map((que) => (
                        <div className="detailItem companyInfo" key={que?.q_id}>
                          <span className="itemKey">{que.question}:</span>
                          <span className="itemValue">{que.answer}</span>
                        </div>
                      ))
                    ) : (
                      <h6>No Data Found</h6>
                    )}
                  </div>
                </div>
              </div>
              <div className="left">
                
                <h1 className="title">Bank Information</h1>

                <div className="item">
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Bank Name:</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.bank_name}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Account Number</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.account_number
                        }
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Bank Institution:</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.institution}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Bank Transit Number</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.transit_number
                        }
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Bank Swift Code</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.swift_code
                        }
                      </span>
                    </div>

                    <div className=" idDocs">
                      <span className="itemKey">Bank Docs</span>
                      <div className="itemValue">
                        <a
                          href={
                            userInfo?.profile_individual_bankdetails?.bankdoc
                          }
                          target="_blank"
                          rel="noreferrer"
                          className="docLink"
                        >
                          {userInfo?.profile_individual_bankdetails?.bankdoc !==
                            null && <img src={PDF} className="docImage" alt="Bank document" />}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Deal Flow: Admin Rating & Interest Stats Section */}
              <div className="left">
                <h1 className="title">Deal Flow Analytics</h1>
                <div className="dealflow-section">
                  <AdminStarRating
                    campaignId={userInfo?.id}
                    initialRating={myRating?.rating || 0}
                    initialNotes={myRating?.notes || ""}
                    onRatingSubmit={() => dispatch(getCampaignRatingsAdmin(campaignId))}
                  />
                  <InterestStatsPanel
                    campaignId={userInfo?.id}
                    currency={userInfo?.currency_type || "USD"}
                  />
                </div>
              </div>
            </div>
          ))}

          <Modal
            open={open}
            onClose={onCloseModal}
            closeOnOverlayClick={false}
            styles={{ modal: { maxWidth: "1000px" } }}
          >
            <h3 className="modal-tittle">Campaign Log History</h3>
            {previewData?.map((campaign, index) => {
              const d = new Date(campaign?.updatedAt);
              return (
                <div key={uuidv4()}>
                  {/* {campaign?.id} */}
                  <Accordion
                    expanded={expanded === `panel_${campaign?.id}`}
                    onChange={handleChange(`panel_${campaign?.id}`)}
                  >
                    <AccordionSummary
                      aria-controls="panel1d-content"
                      id="panel1d-header"
                    >
                      <Typography sx={{ width: "33%", flexShrink: 0 }}>
                        {d?.getHours() +
                          ":" +
                          d?.getMinutes() +
                          ", " +
                          d?.toDateString()}
                      </Typography>
                      <Typography sx={{ color: "text.secondary" }}>
                        Version: {index + 1}
                      </Typography>
                      {/* <Typography sx={{ color: "text.secondary" }}>
                        Version:{campaign?.version_number}
                      </Typography> */}
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography component="span">
                        <div className="accordian-base log-historyAccordian">
                          <div className="title-topSection">
                            <h6 className="accordian-tophead">
                              1. Corporate Information
                            </h6>
                            <p className="accordian-tophead">
                              Launch Date : {campaign?.step_seven?.launchDate}
                            </p>
                          </div>
                          <div className="accordian-info">
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Corpaoration Legal Name
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.corporation_legal_name}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Address</p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.registered_address}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">City</p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.city}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Postal Code</p>
                              <p className="accordianitem-value">
                                {campaign.step_one.postal_code}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Country</p>
                              <p className="accordianitem-value">Canada</p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">State</p>
                              <p className="accordianitem-value">
                                Northwest Territories
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Fax</p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.fax}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Phone</p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.phone}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Website</p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.website}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Entitype</p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.entitytype}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Buisness</p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.business}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Crax Account</p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.craax_account}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Date Of Incorp
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.date_of_incorp}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                How Many Years Of Buisness
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.how_many_yearsin_business}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Campaign Email
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.camp_email}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Goal Amount</p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.goal_invest_amnt}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Minimum Investment
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.minimum_investment}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Other Investment
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.outside_roots_investment}
                              </p>
                            </div>
                            {campaign?.type === "Equity" ? (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Company Valuation
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.company_valuation}
                                </p>
                              </div>
                            ) : (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  In Which Form
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.loan_type}
                                </p>
                              </div>
                            )}
                            {campaign?.type === "Equity" ? (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Closing Minimum
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.no_closing_minimum}
                                </p>
                              </div>
                            ) : (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Brief description on how you will use this
                                  funds
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.fund_use}
                                </p>
                              </div>
                            )}
                            {campaign?.type === "Equity" ? (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Price per security
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.price_per_security}
                                </p>
                              </div>
                            ) : (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Which Is The Purpose Of This Financing?
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.purpose_of_financing}
                                </p>
                              </div>
                            )}
                            {campaign?.type === "Equity" ? (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Security Type
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.security_type}
                                </p>
                              </div>
                            ) : (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Which return you would like to offer to the
                                  investors?
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.interest_rate}
                                </p>
                              </div>
                            )}
                            {campaign?.type === "Equity" ? (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Number of shares issued in this campaign
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.issued_shares}
                                </p>
                              </div>
                            ) : (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  What's your desired loan's duration in months?
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.loan_duration_in_month}
                                </p>
                              </div>
                            )}
                            {campaign?.type === "Equity" ? (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Total Company’s shares issued
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.issued_shares_company}
                                </p>
                              </div>
                            ) : (
                              <div className="accordian-wrapper">
                                <p className="accordianitem-key">
                                  Can you offer any guarantees to the investor?
                                </p>
                                <p className="accordianitem-value">
                                  {campaign?.step_one?.guarantee_type}
                                </p>
                              </div>
                            )}

                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Nature of Buisness
                              </p>
                              <p className="accordianitem-value">
                                {/* {campaign?.step_one?.nature_of_business} */}
                                {Array.isArray(
                                  campaign?.step_one
                                    ?.populated_nature_of_business
                                ) ? (
                                  campaign?.step_one?.populated_nature_of_business?.map(
                                    (cat, index) => {
                                      return (
                                        <li className="itemValue">{cat}</li>
                                      );
                                    }
                                  )
                                ) : (
                                  <h4>No Data Found</h4>
                                )}
                              </p>
                            </div>

                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Feature</p>
                              <p className="accordianitem-value">
                                {/* {campaign?.step_one?.features} */}

                                {Array.isArray(
                                  campaign?.step_one?.populated_features
                                ) ? (
                                  campaign?.step_one?.populated_features?.map(
                                    (cat, index) => {
                                      return (
                                        <li className="itemValue">{cat}</li>
                                      );
                                    }
                                  )
                                ) : (
                                  <h4>No Data Found</h4>
                                )}
                                {/* 
                                {campaign?.step_one?.populated_features
                                  ?.length > 0 ? (
                                  campaign?.step_one?.populated_features?.map(
                                    (cat, i) => (
                                      <>
                                        <li className="itemValue">{cat}</li>
                                      </>
                                    )
                                  )
                                ) : (
                                  <h6>No Data Found</h6>
                                )} */}
                              </p>
                            </div>

                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Buisness Plan Docs
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.business_plan_docs
                                  ?.length > 0 ? (
                                  campaign?.step_one?.business_plan_docs?.map(
                                    (pdf, i) => (
                                      <>
                                        {pdf?.is_other === 0 && (
                                          <a
                                            href={pdf?.document_name}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="docLink"
                                          >
                                            {pdf?.document_name !== null && (
                                              <img
                                                src={PDF}
                                                className="docImage"
                                                alt="Document"
                                              />
                                            )}

                                            {pdf?.document_name !== null && (
                                              <p className="docName">
                                                doc {i + 1}
                                              </p>
                                            )}
                                          </a>
                                        )}
                                      </>
                                    )
                                  )
                                ) : (
                                  <h6>No Data Found</h6>
                                )}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Other Plan Docs
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_one?.business_plan_docs
                                  ?.length > 0 ? (
                                  campaign?.step_one?.business_plan_docs?.map(
                                    (pdf, i) => (
                                      <>
                                        {pdf?.is_other === 1 && (
                                          <a
                                            href={pdf?.document_name}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="docLink"
                                          >
                                            {pdf?.is_other !== null && (
                                              <img
                                                src={PDF}
                                                className="docImage"
                                                alt="Document"
                                              />
                                            )}

                                            {pdf?.is_other !== null && (
                                              <p className="docName">
                                                doc {i + 1}
                                              </p>
                                            )}
                                          </a>
                                        )}
                                      </>
                                    )
                                  )
                                ) : (
                                  <h6>No Data Found</h6>
                                )}
                              </p>
                            </div>
                            {/* for lending products */}
                            {/* {userInfo?.type == "LENDME" ?  */}
                            <div className="detailItem product-drp rating">
                              <span className="itemKey">Select Product</span>
                              <select
                                className="txtInput productSelection-drp"
                                name="product"
                                onChange={(e) => setProductId(e.target.value)}
                                value={productId}
                              >
                                <option value="" disabled selected>
                                  Select Value
                                </option>
                                {productsType.map((getProducts, index) => (
                                  <option
                                    key={index}
                                    value={getProducts.product_name}
                                  >
                                    {getProducts?.product_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {/*
                              DEPRECATED: A/B/C/D Dropdown Rating System (LENDME only)
                              Replaced by 5-star rating system for all campaign types.
                              See: docs/deal_flow_implementation_admin.md for details.
                            */}

                            {/* Deal Flow: Admin rating is available in the analytics panel */}
                          </div>
                        </div>
                        <hr />
                        <div className="accordian-base log-historyAccordian">
                          <h6 className="accordian-tophead">
                            2. Personal Information
                          </h6>
                          <div className="accordian-info">
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">First Name</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.firstname}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Last Name</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.lastname}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Email</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.email}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Phone</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.mobile}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Country</p>
                              <p className="accordianitem-value">Canada</p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">State</p>
                              <p className="accordianitem-value">
                                Northwest Territories
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Current Address
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.current_address}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Address</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.address}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Postal Code</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.postal_code}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Marital Status
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.marital_status}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Gender</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.gender}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Employer</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.employer}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Occupation</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.occupation}
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">DOB</p>
                              <p className="accordianitem-value">
                                {campaign?.step_two?.dob}
                              </p>
                            </div>
                            {/* <div className="idDocs">
                              <span className="itemKey">Id Proof Docs</span>
                              <div className="itemValue">
                                {campaign?.step_two?.id_proof_docs?.length >
                                0 ? (
                                  campaign?.step_two?.id_proof_docs?.map(
                                    (id, i) => (
                                      <>
                                        <a
                                          href={id?.document_name}
                                          target="_blank"
                                          className="docLink"
                                        >
                                          {id?.document_name !== null && (
                                            <img
                                              src={id?.document_name}
                                              className="docImage"
                                            />
                                          )}
                                          {id?.document_name !== null && (
                                            <p className="docName">
                                              doc {i + 1}
                                            </p>
                                          )}
                                        </a>
                                      </>
                                    )
                                  )
                                ) : (
                                  <h6>No Data Found</h6>
                                )}
                              </div>
                            </div> */}
                          </div>
                        </div>
                        <hr />
                        <div className="accordian-base log-historyAccordian">
                          <h6 className="accordian-tophead">
                            3. Campaign related Questions/Answers
                          </h6>
                          <div className="accordian-info">
                            {Array.isArray(campaign?.step_three)
                              ? campaign?.step_three?.map((campaignQueAns) => {
                                  return (
                                    <div
                                      className="campaign-que-ans"
                                      key={uuidv4()}
                                    >
                                      <p className="accordianitem-key">
                                        {campaignQueAns?.question}
                                      </p>
                                      <p className="accordianitem-value">
                                        {campaignQueAns?.answer}
                                      </p>
                                    </div>
                                  );
                                })
                              : ""}
                          </div>
                        </div>
                        <hr />
                        <div className="accordian-base log-historyAccordian">
                          <h6 className="accordian-tophead">
                            4. Bank Information
                          </h6>
                          <div className="accordian-info">
                            <div className="accordian-wrapper">
                              <span className="itemKey">Bank Name:</span>
                              <span className="itemValue">
                                {campaign?.step_four?.bank_name}
                              </span>
                            </div>
                            <div className="accordian-wrapper">
                              <span className="itemKey">Bank Public Code:</span>
                              <span className="itemValue">
                                {campaign?.step_four?.bankPublicCode}
                              </span>
                            </div>

                            <div className="accordian-wrapper">
                              <span className="itemKey">
                                Bank Office Address
                              </span>
                              <span className="itemValue">
                                {campaign?.step_four?.bank_address}
                              </span>
                            </div>
                            <div className="accordian-wrapper">
                              <span className="itemKey">Bank Phone:</span>
                              <span className="itemValue">
                                {campaign?.step_four?.bank_phone_number}
                              </span>
                            </div>
                            <div className="accordian-wrapper">
                              <span className="itemKey">Postal Code</span>
                              <span className="itemValue">
                                {campaign?.step_four?.postal_code}
                              </span>
                            </div>
                            <div className="accordian-wrapper">
                              <span className="itemKey">City:</span>
                              <span className="itemValue">
                                {campaign?.step_four?.city}
                              </span>
                            </div>
                            <div className="accordian-wrapper">
                              <span className="itemKey">Street Name:</span>
                              <span className="itemValue">
                                {campaign?.step_four?.street_name}
                              </span>
                            </div>
                            <div className="accordian-wrapper">
                              <span className="itemKey">Account Number</span>
                              <span className="itemValue">
                                {campaign?.step_four?.account_number}
                              </span>
                            </div>
                            <div className="accordian-wrapper">
                              <span className="itemKey">Bank Institution:</span>
                              <span className="itemValue">
                                {campaign?.step_four?.institution}
                              </span>
                            </div>

                            <div className="accordian-wrapper">
                              <span className="itemKey">
                                Bank Transit Number
                              </span>
                              <span className="itemValue">
                                {campaign?.step_four?.transit_number}
                              </span>
                            </div>
                            <div className="accordian-wrapper">
                              <span className="itemKey">IBAN</span>
                              <span className="itemValue">
                                {campaign?.step_four?.iban}
                              </span>
                            </div>
                            <div className="accordian-wrapper">
                              <span className="itemKey">Bank Docs</span>
                              <div className="itemValue">
                                <a
                                  href={campaign?.step_four?.bankdoc}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="docLink"
                                >
                                  {campaign?.step_four?.bankdoc !== null && (
                                    <img
                                      src={campaign?.step_four?.bankdoc}
                                      className="docImage"
                                      alt="Bank document"
                                    />
                                  )}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="accordian-base log-historyAccordian">
                          <h6 className="accordian-tophead">5. AboutUs</h6>
                          <div className="accordian-info">
                            <div className="about-us-wrapper">
                              <p className="accordianitem-key">Content</p>
                              <p
                                className="accordianitem-value"
                                dangerouslySetInnerHTML={{
                                  __html: campaign?.step_five?.description,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="accordian-base log-historyAccordian">
                          <h6 className="accordian-tophead">6. Our Teams</h6>
                          <div className="accordian-info">
                            <div className="accordian-wrapper our-team-accordian">
                              <div className="team-wrapper">
                                {Array.isArray(campaign?.step_six?.teams)
                                  ? campaign?.step_six?.teams?.map(
                                      (ourteam) => {
                                        return (
                                          <div className="team-subdiv">
                                            <img
                                              src={ourteam?.profile_pic}
                                              alt={
                                                `${ourteam?.firstname || ""} ${ourteam?.lastname || ""}`.trim() ||
                                                "Team member"
                                              }
                                              className="team-subdiv-image"
                                            />
                                            <h3>
                                              {ourteam?.firstname}{" "}
                                              {ourteam?.lastname}
                                            </h3>
                                            <span>{ourteam?.designation}</span>
                                            <div className="team-social">
                                              {/* <a>
                                                <FaGoogle className="social-icon" />
                                              </a> */}
                                              {ourteam?.facebookurl === "" ? (
                                                ""
                                              ) : (
                                                <a href={ourteam?.facebookurl}>
                                                  <FaFacebook className="social-icon" />
                                                </a>
                                              )}
                                              {ourteam?.linkedinurl === "" ? (
                                                ""
                                              ) : (
                                                <a href={ourteam?.linkedinurl}>
                                                  <FaLinkedin className="social-icon" />
                                                </a>
                                              )}
                                            </div>
                                            <p>{ourteam?.about_profile}</p>
                                          </div>
                                        );
                                      }
                                    )
                                  : ""}

                                {/* <div className="team-subdiv">
                                  <img
                                    src={ProfilePic}
                                    alt=""
                                    className="team-subdiv-image"
                                  />
                                  <h3>Akash</h3>
                                  <span>Software Developer</span>
                                  <div className="team-social">
                                    <a>
                                      <FaGoogle className="social-icon" />
                                    </a>
                                    <a>
                                      <FaFacebook className="social-icon" />
                                    </a>
                                    <a>
                                      <FaLinkedin className="social-icon" />
                                    </a>
                                  </div>
                                  <p>
                                    Lorem ipsum is a placeholder text commonly
                                    used to demonstrate the visual form of a
                                    document or a typeface without relying on
                                    meaningful content.{" "}
                                  </p>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr />
                        <div className="accordian-base log-historyAccordian">
                          <h6 className="accordian-tophead">7. Terms</h6>
                          <div className="accordian-info">
                            {Array.isArray(campaign?.step_seven?.terms)
                              ? campaign?.step_seven?.terms.map((termsData) => {
                                  return (
                                    <>
                                      {/* <div className="accordian-wrapper">
                                        <p className="accordianitem-key">
                                          First Name
                                        </p>
                                        <p className="accordianitem-value">
                                          ABC
                                        </p>
                                      </div> */}
                                      <table className="terms-tbl">
                                        {/* <tr>
                                          <th>Contact</th>
                                          <th>Country</th>
                                        </tr> */}
                                        <thead>
                                          <tr>
                                            <th>Main Category</th>
                                            <th>Security Type</th>
                                            <th>Maximum Offering</th>
                                            <th>Minimum Investment</th>
                                            <th>Price Per Security</th>
                                            <th>Eligible</th>
                                          </tr>
                                        </thead>
                                        <tr>
                                          <td>{termsData?.main_category}</td>
                                          <td>{termsData?.security_type}</td>
                                          <td>{termsData?.maximum_offering}</td>
                                          <td>
                                            {termsData?.minimum_investment}
                                          </td>
                                          <td>
                                            {termsData?.price_per_security}
                                          </td>
                                          <td>
                                            {termsData?.rrsp_tfsa_eligible}
                                          </td>
                                        </tr>
                                      </table>
                                    </>
                                  );
                                })
                              : ""}
                          </div>
                        </div>
                        <hr />
                        <div className="accordian-base log-historyAccordian">
                          <h6 className="accordian-tophead">8. News</h6>
                          <div className="accordian-info">
                            {Array.isArray(campaign?.step_eight)
                              ? campaign?.step_eight?.map((News) => {
                                  return (
                                    <div
                                      className="accordian-wrapper"
                                      id="accordian-news-wrapper"
                                    >
                                      {/* <p className="accordianitem-key">News</p> */}
                                      <div
                                        className="accordianitem-value"
                                        dangerouslySetInnerHTML={{
                                          __html: News?.news,
                                        }}
                                      ></div>
                                    </div>
                                  );
                                })
                              : ""}
                          </div>
                        </div>
                        <hr />
                        <div className="accordian-base log-historyAccordian">
                          <h6 className="accordian-tophead">
                            9. FAQs, Logo, Tagline & Social Media URLs
                          </h6>

                          <div className="accordian-info">
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Tagline</p>
                              <p className="accordianitem-value">
                                {campaign?.step_nine?.tagline}
                              </p>
                            </div>

                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">Logo</p>
                              <p className="accordianitem-value">
                                <img
                                  src={campaign?.step_nine?.campaing_logo}
                                  alt="Campaign logo"
                                  className="team-subdiv-image"
                                />
                              </p>
                            </div>
                            <div className="accordian-wrapper">
                              <p className="accordianitem-key">
                                Campaign Banner
                              </p>
                              <p className="accordianitem-value">
                                {campaign?.step_nine?.banner_img ? (
                                  <img
                                    src={campaign?.step_nine?.banner_img}
                                    alt="Campaign banner"
                                    className="team-subdiv-image"
                                  />
                                ) : (
                                  "No Data Found"
                                )}
                              </p>
                            </div>
                            {/* <div className="accordian-wrapper">
                              <p className="accordianitem-key">Comment</p>
                              <p className="accordianitem-value">
                                <p className="accordianitem-value">
                                  {campaign?.step_nine?.comment}
                                </p>
                              </p>
                            </div> */}
                          </div>
                        </div>
                        <hr />

                        <div className="accordian-base">
                          <div className="comment-section">
                            <h6 className="accordian-tophead">10. Comment:</h6>
                            <span className="accordianitem-value">
                              {campaign?.comment}
                            </span>
                          </div>
                        </div>

                        {/* Approval Section - Only shown for Admin/SuperAdmin, hidden for Evaluators */}
                        {campaign?.isForAdminReview === 1 && canApprove() ? (
                          <>
                            <hr />
                            <div className="accordian-base log-historyAccordian">
                              <h6 className="accordian-tophead">
                                You can click on Approve / Reject button below
                                to respond.
                              </h6>
                              <span className="status-note-msg">
                                <b>Note</b>: Before Approve/Reject campaign
                                please check it's log history.{" "}
                              </span>
                              <div className="accordian-info">
                                <div className="accordian-wrapper">
                                  <div className="draftSaveButton">
                                    <Button
                                      variant="contained"
                                      className="draftapproveButton"
                                      onClick={approveCampaign}
                                    >
                                      Approve
                                    </Button>
                                    <Button
                                      variant="contained"
                                      className="draftdeclineButton"
                                      onClick={declineCampaign}
                                    >
                                      Reject
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : campaign?.isForAdminReview === 1 && isEvaluator() ? (
                          <>
                            <hr />
                            <div className="accordian-base log-historyAccordian">
                              <div className="evaluator-notice" style={{ padding: "16px", background: "#fff3e0", borderRadius: "8px", textAlign: "center" }}>
                                <h6 style={{ color: "#e65100", marginBottom: "8px" }}>Evaluator Access</h6>
                                <p style={{ color: "#666", margin: 0, fontSize: "14px" }}>
                                  As an Evaluator, you can rate campaigns but cannot approve or reject them.
                                </p>
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </div>
              );
            })}
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default ReviewCampaign;
